module.exports = __webpack_public_path__ + "img/tpOrientacoes-2.dd89315f.png";